<ng-container
  *ngIf="{
    amountMissing:
      formSubmitted && !calculateAttempted && !!form.controls.targetRecurringPaymentAmount.errors?.required,
    amountInvalid:
      form.controls.targetRecurringPaymentAmount.invalid &&
      (calculateAttempted || (formSubmitted && !form.controls.targetRecurringPaymentAmount.errors?.required))
  } as errorState">
  <div class="d-flex flex-column gap-3">
    <div class="d-flex align-items-center gap-4">
      <div class="d-flex align-items-center flex-grow-1 gap-4">
        <div class="d-flex flex-column gap-2">
          <div class="form-input-label" i18n>Combined Minimum:</div>
          <div class="title-sm">{{ combinedMinimum | currency }}</div>
        </div>
        <div class="d-flex flex-column gap-2">
          <div class="form-input-label" i18n>Combined Maximum:</div>
          <div class="title-sm">{{ combinedMaximum | currency }}</div>
        </div>
      </div>
      <div class="d-flex flex-column gap-3" [style.width.rem]="18.75">
        <div class="d-flex flex-column gap-1">
          <label i18n class="form-input-label" [for]="'targetRecurringPaymentAmount'">Target Payment Amount</label>
          <app-recurring-currency-input
            controlId="targetRecurringPaymentAmount"
            [formControl]="form.controls.targetRecurringPaymentAmount"
            [error]="errorState.amountInvalid"
            [frequency]="
              form.controls.recurringPaymentFrequencyId.value === VariableBenefitPaymentFrequencyEnum.Annual
                ? 'annual'
                : 'monthly'
            " />
          <div *ngIf="!errorState.amountInvalid" i18n class="form-input-hint">Enter an amount and click Calculate</div>
          <app-form-error
            *ngIf="errorState.amountInvalid"
            [errors]="form.controls.targetRecurringPaymentAmount.errors"
            [customErrorMessages]="customErrorMessages" />
        </div>
        <app-text-button
          class="d-flex justify-content-end"
          [type]="ButtonTypeEnum.accent"
          [disabled]="isCalculating"
          (buttonClicked)="onCalculateClicked()">
          <div class="d-flex align-items-center gap-2 justify-content-end">
            <span i18n>Calculate</span>
            <img
              *ngIf="!isCalculating"
              src="assets/icons/primary/Calculator.svg"
              [style.height.rem]="1.125"
              [style.width.rem]="1.125"
              alt="" />
            <img
              *ngIf="isCalculating"
              class="calculating"
              src="assets/icons/grey/Loading.svg"
              [style.height.rem]="1.125"
              [style.width.rem]="1.125"
              alt="" />
          </div>
        </app-text-button>
      </div>
    </div>
    <div *ngIf="errorState.amountMissing" role="alert" class="paragraph-md red-text" i18n>
      Configure a target payment amount or custom payment to continue
    </div>
    <app-banner-alert *ngIf="warningBanner" role="status" [alert]="warningBanner" />
  </div>
</ng-container>
